export const getPageType = (path = '') => {
  const normalizedPath = path.toLowerCase().replace(/^\/render[^/]*/, '');

  if (normalizedPath.includes('/b/')) {
    return 'browse';
  }

  if (normalizedPath.includes('/s/')) {
    return 'search';
  }

  return null;
};